import { MinusOutlined } from '@ant-design/icons';
import { useFormItemEnabled } from '@framework/form';
import { t } from '@framework/i18n';
import { ButtonDeleteConfirm } from '@framework/ui';
import { Button, Tooltip } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { IRepeatableWidget } from '../IRepeatableWidget';
import { AlignItemWrapper } from '../style/RepeatableContainer';

export interface IRemoveRowButtonProps {
  widget: IRepeatableWidget;
  index: number;
  onRemove: (index: number) => void;
  itemCount: number;
}

/**
 * Bottone per l'eliminazione di una specifica riga in un repeatable widget.
 */
export function RemoveRowButton(props: IRemoveRowButtonProps) {
  const { widget, index, onRemove, itemCount } = props;

  const repeatRule = widget.rules?.repeatableRange;
  const isMin = useMemo(
    () => repeatRule?.min && itemCount <= repeatRule.min,
    [itemCount, repeatRule],
  );

  const { enabled } = useFormItemEnabled();

  const handleOnClick = useCallback(() => {
    if (isMin) return;
    onRemove(index);
  }, [index, isMin, onRemove]);

  return (
    <AlignItemWrapper>
      <Tooltip
        title={
          //  Se è disabilitato non mostro il tooltip
          enabled && isMin
            ? t(
                'widgets.remove-row-buttton.min-options-reached',
                'Numero minimo di opzioni raggiunto',
              )
            : undefined
        }
      >
        {widget.layout?.showConfirmDelete ? (
          <ButtonDeleteConfirm
            size="large"
            disabled={!enabled || itemCount <= (repeatRule?.min ?? 0)}
            buttonIcon={<MinusOutlined aria-label="Rimuovi" />}
            title={widget.layout?.confirmDeleteTitle}
            okText={widget.layout?.confirmDeleteButtonLabel}
            cancelText={widget.layout?.cancelDeleteButtonLabel}
            iconOnlyButton
            // buttonDanger
            buttonType="default"
            onConfirm={handleOnClick}
          />
        ) : (
          <Button
            aria-label="Rimuovi"
            size="large"
            disabled={!enabled || itemCount <= (repeatRule?.min ?? 0)}
            icon={<MinusOutlined aria-hidden />}
            onClick={handleOnClick}
          />
        )}
      </Tooltip>
    </AlignItemWrapper>
  );
}
